import React, { useRef, useState, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CategoriesValue } from "../../../../../types/Card";

interface CategoriesProps {
  categoryData: CategoriesValue[];
  selectedCategory: string | null;
  handleCategoryClick: (slug: string) => void;
}

const Categories = (props: CategoriesProps) => {
  const { categoryData, selectedCategory, handleCategoryClick } = props;
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [showLeftFade, setShowLeftFade] = useState(false);
  const [showRightFade, setShowRightFade] = useState(false);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeftFade(el.scrollLeft > 0);
    setShowRightFade(el.scrollWidth > el.clientWidth + el.scrollLeft);
  };

  useEffect(() => {
    checkScroll(); // Initial check
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
    }
    return () => {
      if (el) el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  return (
    <Box
      mt={2}
      sx={{
        // mb: !selectedCategory ? 4 : 0,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Left Gradient */}
      {showLeftFade && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 40,
            height: "100%",
            background: "linear-gradient(to right, white, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
      )}

      {/* Right Gradient */}
      {showRightFade && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: -1,
            width: 40,
            height: "100%",
            background: "linear-gradient(to left, white, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
      )}

      {/* Scrollable Category List */}
      <Stack
        direction="row"
        gap={1}
        mt={1}
        ref={scrollRef}
        onScroll={checkScroll}
        sx={{
          overflowX: "auto",
          zIndex: 1,
          position: "relative",
          scrollBehavior: "smooth",
          paddingBottom: "15px",

          // Hide scrollbar (WebKit-based browsers)
          "&::-webkit-scrollbar": {
            display: "none",
          },

          // Hide scrollbar (Firefox)
          scrollbarWidth: "none",

          // Hide scrollbar (Internet Explorer and Edge Legacy)
          msOverflowStyle: "none",

          // Custom scrollbar styles
          // "&::-webkit-scrollbar": {
          //   height: "2px",
          //   visibility:"hidden",

          // },
          // "&::-webkit-scrollbar-thumb": {
          //   backgroundColor: "var(--neutral-200)",
          //   borderRadius: "10px",
          // },
          // "&::-webkit-scrollbar-track": {
          //   backgroundColor: "transparent",
          // },
        }}
      >
        {categoryData.map((cat: any) => (
          <Box
            key={cat.slug}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "5px",
              minWidth: "100px",
              cursor: "pointer",
            }}
            onClick={() => handleCategoryClick(cat.slug)}
          >
            <Box
              component="img"
              height="75px"
              width="75px"
              src={cat?.image}
              sx={{
                borderRadius: "100%",
                backgroundColor: "var(--primary-100)",
                border: "none",
                display: "block",
                objectFit: "cover",
              }}
            />
            <Typography
              sx={{
                font: "var(--semibold-xs)",
                textAlign: "center",
                color:
                  selectedCategory === cat.slug
                    ? "var(--primary-700)"
                    : "var(--neutralBlack)",
              }}
              maxWidth="100px"
            >
              {cat.name}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default Categories;
